import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList } from "@/api/system/role";
import { getPlanDesktopVoList, createPlanDesktop, deletePlanDesktop, editPlanDesktop } from "@/api/management/showcase";
import ShowcaseConfig from "./showcaseConfig";
export default {
  name: "showcase",
  components: {
    ShowcaseConfig: ShowcaseConfig
  },
  data: function data() {
    return {
      current: 1,
      size: 10,
      total: 0,
      list: [],
      title: "新增方案",
      showDialog: false,
      formValidate: {
        deskName: "",
        roleIds: [],
        deskId: ""
      },
      ruleValidate: {
        deskName: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        roleIds: [{
          required: true,
          message: "请选择应用角色",
          trigger: "blur"
        }]
      },
      roleList: [],
      subDisabled: false,
      loading: false,
      goingToShowcaseConfig: false,
      showcaseConfig: false,
      showcaseConfigData: {
        deskId: "",
        deskName: "",
        deskType: ""
      },
      clickRow: {}
    };
  },
  created: function created() {
    this.getRoleList();
    this.initCaseList();
  },
  computed: {},
  methods: {
    getPageDeskVo: function getPageDeskVo(row) {
      var _this = this;

      this.clickRow = row;
      this.goingToShowcaseConfig = true;
      this.$store.dispatch("getPageDeskVo", row.deskId).then(function () {
        _this.goShowcaseConfig(row);
      }).catch(function (msg) {
        _this.$message.error(msg);
      }).finally(function () {
        _this.goingToShowcaseConfig = false;
      });
    },
    goShowcaseConfig: function goShowcaseConfig(row) {
      this.showcaseConfigData.deskId = row.deskId;
      this.showcaseConfigData.deskName = row.deskName;
      this.showcaseConfigData.deskType = "role";
      this.showcaseConfig = true;
    },
    closeShowcaseConfig: function closeShowcaseConfig() {
      this.showcaseConfig = false;
    },
    closeShowcaseDialog: function closeShowcaseDialog() {
      this.$refs.showcaseConfig.closeShowcaseConfig();
    },
    initCaseList: function initCaseList() {
      this.current = 1;
      this.getCaseList();
    },
    getCaseList: function getCaseList() {
      var _this2 = this;

      this.loading = true;
      var obj = {
        current: this.current,
        size: this.size
      };
      getPlanDesktopVoList(obj).then(function (_ref) {
        var data = _ref.data;

        if (data.code === 0) {
          _this2.list = data.data.records;
          _this2.total = data.data.total;
        } else {
          _this2.$message.error(data.msg);
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    changePage: function changePage(page) {
      this.current = page;
      this.getCaseList();
    },
    getRoleList: function getRoleList() {
      var _this3 = this;

      getList().then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this3.roleList = data.data;
        } else {
          _this3.$message.error(data.msg);
        }
      });
    },
    addCase: function addCase() {
      this.title = "新增方案";
      this.showDialog = true;
    },
    editCase: function editCase(row) {
      this.title = "编辑方案";
      this.formValidate = {
        deskName: row.deskName,
        deskId: row.deskId,
        roleIds: row.roleIds.split(",")
      };
      this.showDialog = true;
    },
    deleteCase: function deleteCase(row) {
      var _this4 = this;

      this.$confirm("\u786E\u5B9A\u5220\u9664".concat(row.deskName, "\u5417"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        deletePlanDesktop({
          deskId: row.deskId
        }).then(function (_ref3) {
          var data = _ref3.data;

          if (data.code == 0) {
            _this4.$message({
              type: "success",
              message: "删除成功!"
            });

            _this4.initCaseList();
          } else {
            _this4.$message.error(data.msg);
          }
        });
      });
    },
    closeDialog: function closeDialog() {
      this.showDialog = false; // this.$refs.formValidate.resetFields();

      this.formValidate = {
        deskName: "",
        deskId: "",
        roleIds: []
      };
    },
    submit: function submit() {
      var _this5 = this;

      this.$refs.formValidate.validate(function (valid) {
        if (valid) {
          if (_this5.title === "新增方案") {
            createPlanDesktop(_this5.formValidate).then(function (_ref4) {
              var data = _ref4.data;

              if (data.code == 0) {
                _this5.$message.success("添加方案成功");

                _this5.closeDialog();

                _this5.initCaseList();
              } else {
                _this5.$message.error(data.msg);
              }
            });
          } else {
            editPlanDesktop(_this5.formValidate).then(function (_ref5) {
              var data = _ref5.data;

              if (data.code == 0) {
                _this5.$message.success("编辑方案成功");

                _this5.closeDialog();

                _this5.initCaseList();
              } else {
                _this5.$message.error(data.msg);
              }
            });
          }
        }
      });
    }
  }
};